import { terveystaloBrand } from '../definitions/default';
import { toCSSVarCase } from './convert';
/**
 * Creates a CSS custom property for the given semantic token variable with a fallback value.
 *
 * This effectively binds the property to utilise the branding support.
 *
 * @param variable the custom property name
 * @param fallbackValue the custom property fallback value. Adds quotes automatically in when needed
 * @returns CSS custom property
 */
export function bindToBrand(path) {
    const variable = `--${toCSSVarCase(path, '', '.')}`;
    const fallback = getByPath(path, terveystaloBrand);
    return `var(${variable}, ${fallback})`;
}
function getByPath(path, obj) {
    let current = obj;
    path.split('.').forEach(function (part) {
        current = current[part];
    });
    return current;
}
